import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action } from '@ngrx/store';
import {
  FinalDisciplinaryActionActions,
  FinalDisciplinaryActionActionTypes,
} from './final-disciplinary-action.actions';
import { FinalDisciplinaryActionEntity } from './final-disciplinary-action.model';

export interface FinalDisciplinaryActionEntities
  extends EntityState<FinalDisciplinaryActionEntity> {
  // additional entities state properties
}

export const adapter: EntityAdapter<FinalDisciplinaryActionEntity> = createEntityAdapter<
  FinalDisciplinaryActionEntity
>();

export const initialState: FinalDisciplinaryActionEntities = adapter.getInitialState({
  // additional entity state properties
});

export function reducer(
  state = initialState,
  incomingAction: Action,
): FinalDisciplinaryActionEntities {
  const action = incomingAction as FinalDisciplinaryActionActions;
  switch (action.type) {
    case FinalDisciplinaryActionActionTypes.AddFinalDisciplinaryAction: {
      return adapter.addOne(action.payload.finalDisciplinaryAction, state);
    }

    case FinalDisciplinaryActionActionTypes.UpsertFinalDisciplinaryAction: {
      return adapter.upsertOne(action.payload.finalDisciplinaryAction, state);
    }

    case FinalDisciplinaryActionActionTypes.AddFinalDisciplinaryActions: {
      return adapter.addMany(action.payload.finalDisciplinaryActions, state);
    }

    case FinalDisciplinaryActionActionTypes.UpsertFinalDisciplinaryActions: {
      return adapter.upsertMany(action.payload.finalDisciplinaryActions, state);
    }

    case FinalDisciplinaryActionActionTypes.UpdateFinalDisciplinaryAction: {
      return adapter.updateOne(action.payload.finalDisciplinaryAction, state);
    }

    case FinalDisciplinaryActionActionTypes.UpdateFinalDisciplinaryActions: {
      return adapter.updateMany(action.payload.finalDisciplinaryActions, state);
    }

    case FinalDisciplinaryActionActionTypes.DeleteFinalDisciplinaryAction: {
      return adapter.removeOne(action.payload.id, state);
    }

    case FinalDisciplinaryActionActionTypes.DeleteFinalDisciplinaryActions: {
      return adapter.removeMany(action.payload.ids, state);
    }

    case FinalDisciplinaryActionActionTypes.LoadFinalDisciplinaryActions: {
      return adapter.setAll(action.payload.finalDisciplinaryActions, state);
    }

    case FinalDisciplinaryActionActionTypes.ClearFinalDisciplinaryActions: {
      return adapter.removeAll(state);
    }

    default: {
      return state;
    }
  }
}

export const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors();
